import { key, notify } from '@databases/ping-registry';
import { createCheckboxEffect } from '@databases/selections';
import { type DatabaseAdapter } from '@databases/selections-api-types';
import { TABLE_V2_LAYOUT_ID } from '@databases/view-layout-table-v2/id';

import {
  type SelectionEffectFeature,
  SelectionFeatureKeys,
} from '../../features/types.ts';

export function createCheckboxEffectFeature(deps: {
  databaseAdapter: DatabaseAdapter;
}): SelectionEffectFeature {
  return {
    key: SelectionFeatureKeys.CHECKBOX_EFFECT,
    type: 'effect',
    isEnabled: ({ layoutType }) => layoutType !== TABLE_V2_LAYOUT_ID,
    factory: () =>
      createCheckboxEffect({
        databaseAdapter: deps.databaseAdapter,
        notifyRowSelected: (entryId: string, selected: boolean) => {
          const rowKey = key('row', { entryId });

          notify(rowKey, 'selected', selected);
        },
        notifyHeaderCheckboxState: (state) => {
          const headerKey = key('headerCheckbox', {});

          notify(headerKey, 'state', state);
        },
      }),
  };
}
